const {ROUTE_ANCHOR_RECIPES} = require('./anchor-recipes.data.cjs')

const DYNAMIC_MARKER = 'data-guide-dynamic'

function normalizeText(value) {
  return String(value || '').replace(/\s+/g, ' ').trim()
}

function isVisible(element) {
  if (!element || !element.isConnected) return false
  const style = window.getComputedStyle(element)
  const rect = element.getBoundingClientRect()
  return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0
}

function matchesText(element, recipe) {
  const actual = normalizeText(element.textContent)
  const expected = recipe.texts || (recipe.text ? [recipe.text] : [])
  if (!expected.length) return true
  return expected.some((item) => recipe.contains
      ? actual.includes(normalizeText(item))
      : actual === normalizeText(item))
}

function clearDynamicAnchors(documentRef = document) {
  documentRef.querySelectorAll(`[${DYNAMIC_MARKER}="true"]`).forEach((element) => {
    element.removeAttribute('data-guide')
    element.removeAttribute(DYNAMIC_MARKER)
  })
}

/**
 * 在 Vue 完成当前页面渲染后，为真实控件补上稳定锚点。
 * 同一路由内的重复行操作会共享同一锚点，定位不依赖具体行号或业务数据。
 */
export function prepareRouteGuideAnchors(routeName, documentRef = document) {
  if (!documentRef || !routeName) return 0
  clearDynamicAnchors(documentRef)
  let count = 0
  for (const recipe of ROUTE_ANCHOR_RECIPES[routeName] || []) {
    const matches = [...documentRef.querySelectorAll(recipe.selector)]
        .filter((element) => matchesText(element, recipe))
        .filter((element) => isVisible(element))
    const selected = recipe.all ? matches : matches.slice(0, 1)
    selected.forEach((element) => {
      // 固定锚点（例如 CurrentActionGuide）优先保留，不被动态映射覆盖。
      if (element.hasAttribute('data-guide') && !element.hasAttribute(DYNAMIC_MARKER)) return
      element.setAttribute('data-guide', recipe.anchor)
      element.setAttribute(DYNAMIC_MARKER, 'true')
      count += 1
    })
  }
  return count
}

export function disposeRouteGuideAnchors(documentRef = document) {
  if (documentRef) clearDynamicAnchors(documentRef)
}
